import { React, useEffect, useState } from "react";
import { Button, Skeleton, Tooltip } from "antd";
import { Styled } from "../../Pages/pageStyled";
import {
  lengthUnit,
  weightUnit,
} from "../../Utils/Constant/MeasurementUnitList";
import IcoMoon from "react-icomoon";
import Iconmoon from "../IconsFiles/icon";
import dragIcon from "../../Assets/Icons/drag-and-drop-icon.svg";
const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

const JobCardCylinderChild = ({
  classname,
  order,
  multiview,
  units,
  trimloss,
  totalWidth,
  maxWidth,
  handleDrag,
  handleDrop,
  uuid,
  isValidState = false,
  reRender,
  deckleMatchPage = false,
}) => {
  const factor = order.width / totalWidth;
  const diff = maxWidth - totalWidth;
  const [availableWidth, setAvailableWidth] = useState(0);

  const cylinderText =
    order.item_type === "trim_loss"
      ? `${order.item_type === "trim_loss" ? trimloss : ""}`
      : `${
          order.grain === "long"
            ? order.order_width > order.order_length
              ? order.order_length
              : order.order_width
            : order.order_length > order.order_width
            ? order.order_length
            : order.order_width
        }`;

  const cylinderTextWithUnits =
    order.item_type === "trim_loss"
      ? `
    ${order.item_type === "trim_loss" ? trimloss : ""} 
    ${
      units
        ? order.item_type === "trim_loss"
          ? lengthUnit[units.trim_loss]?.displayName
          : lengthUnit[units.order_width]?.displayName
        : "cm"
    }
  `
      : order?.order_type === "reel"
      ? `
      ${order.order_width} ${
          units
            ? order.item_type === "trim_loss"
              ? lengthUnit[units.trim_loss]?.displayName
              : lengthUnit[units.order_width]?.displayName
            : "cm"
        } `
      : `
  ${
    order.grain === "long"
      ? order.order_width > order.order_length
        ? order.order_length
        : order.order_width
      : order.order_length > order.order_width
      ? order.order_length
      : order.order_width
  } ${
          units
            ? order.item_type === "trim_loss"
              ? lengthUnit[units.trim_loss]?.displayName
              : lengthUnit[units.order_width]?.displayName
            : "cm"
        } `;
  // console.log(cylinderText.length);
  // const [reRender, setRerender] = useState(false);
  const handleCheckAvailableWidth = () => {
    const spanElement = document.getElementById(
      JSON.stringify({
        uuid: uuid,
        combinationNumber: order.combinationNumber,
      })
    );
    // console.log(spanElement, document)
    if (spanElement) {
      setAvailableWidth(spanElement.offsetWidth);
    }
  };
  useEffect(() => {
    handleCheckAvailableWidth();
  }, [reRender]);

  return (
    <div
      class={classname}
      style={{
        width: `calc(${factor * 100}% )`,
        left: order.left,
        // border: isValidState && '2px solid #a2a2a2',
        // boxSizing: "border-box",
        boxShadow: isValidState && "0 3px 12px rgb(0 0 0 / 0.2)",
      }}
    >
      {/* {isLoading ? (
        <Skeleton.Button
          active={true}
          style={{ width: "90%" }}
          size={"large"}
          shape={"default"}
          block={true}
          className="shimmer"
        />
      ) : ( */}
      <Tooltip
        title={
          (order.item_type === "trim_loss"
            ? `Type: Trim Loss \nWeight: ${order.weight} ${
                units
                  ? capitalize(weightUnit[units.weight]?.displayName)
                  : "Tonnes"
              } \nTrim Loss: ${trimloss} ${
                units
                  ? lengthUnit[units.trim_loss]?.displayName?.toUpperCase()
                  : "CM"
              } `
            : order.item_type === "product_stock_size" ||
              order.item_type === "stock"
            ? `Stock No.: ${order.id} \n Size: ${
                order.order_type === "reel"
                  ? order.order_length > 0 && order.order_width > 0
                    ? `${order.order_width} x ${order.order_length}`
                    : `${order.order_width}`
                  : order.order_type === "sheet"
                  ? `${order.order_width} x ${order.order_length}`
                  : ""
              } ${
                units
                  ? lengthUnit[units.order_width]?.displayName?.toUpperCase()
                  : "CM"
              } \n Type: ${capitalize(order.order_type)} \nWeight: ${
                order.weight ? order.weight.toFixed(3) : ""
              } ${
                units
                  ? capitalize(weightUnit[units.weight]?.displayName)
                  : "Tonnes"
              } \nPriority: ${order.priority ? "Yes" : "No"} `
            : `Order No.: ${order.order} \n Size: ${
                order.order_type === "reel"
                  ? `${order.order_width}`
                  : order.order_type === "sheet"
                  ? `${order.order_width} x ${order.order_length}`
                  : ""
              } ${
                units
                  ? lengthUnit[units.order_width]?.displayName?.toUpperCase()
                  : "CM"
              } \n Type: ${capitalize(order.order_type)} \nWeight: ${
                order.weight ? order.weight.toFixed(3) : ""
              }  ${
                units
                  ? capitalize(weightUnit[units.weight]?.displayName)
                  : "Tonnes"
              } \nPriority: ${order.priority ? "Yes" : "No"} `) +
          "\n" +
          (isValidState ? `Draggable: Yes` : ``)
        }
      >
        <span
          style={{
            padding: "34px 20px 6px 10px",
            display: "inline-flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "85%",
            height: "100%",
            textAlign: "center",
            // marginRight: '5px'
          }}
          className={`cylinder-text${uuid}`}
          draggable={isValidState}
          onDragOver={(ev) => ev.preventDefault()}
          onDragStart={handleDrag}
          onDrop={handleDrop}
          id={JSON.stringify({
            uuid: uuid,
            combinationNumber: order.combinationNumber,
          })}
        >
          {availableWidth >= 40 || deckleMatchPage ? (
            <>
              {isValidState && availableWidth >= 40 && (
                // <div style={{ width: "100%" }}>
                <svg
                  style={{
                    position: "absolute",
                    top: "35%",
                    // alignSelf: "center",
                    width: "15px",
                    opacity: "0.7",
                    // left: "50%",
                    // transform: "translate(-100%, -50%)",
                  }}
                  viewBox="64 64 896 896"
                  focusable="false"
                  data-icon="holder"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"></path>
                </svg>
                // </div>
              )}
              {/* <div style={{position: 'absolute', left: '30%'}}> */}
              {availableWidth >= 50 || order.width > 50 ? (
                <span
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                    width: "85%",
                  }}
                >
                  {cylinderTextWithUnits}
                </span>
              ) : (
                //   availableWidth >= cylinderText.length * 6 ? (
                //   <span
                //     style={{
                //       overflow: "hidden",
                //       textOverflow: "ellipsis",
                //       whiteSpace: "nowrap",
                // display: "block",
                // width: "85%",
                //     }}
                //   >
                //     {cylinderText}
                //   </span>
                // ) : (
                <> </>
              )}
              {/* </div>  */}
            </>
          ) : (
            <></>
          )}
        </span>
      </Tooltip>
    </div>
  );
};

export default JobCardCylinderChild;
